import { HardshipApplicationParam } from "pages/HardshipApplication/reducer/types";

// const GROUP_ID_AU = 360002312898;
// const GROUP_ID_NZ = 360002369658;

// const FORM_ID_AU = 360000574738;
// const FORM_ID_NZ = 360001669578;

// TODO removing zendesk integration in hardship
export async function createHardshipApplication(
  param: HardshipApplicationParam,
) {
  // const { isProduction, isNZ, fields } = param;
  // const groupId = isNZ ? GROUP_ID_NZ : GROUP_ID_AU;
  // const ticketResponse = await createTicket({
  //   isProduction,
  //   requesterName: fields.personalDetails.applicantDetails.email,
  //   requesterEmail: fields.personalDetails.applicantDetails.email,
  //   ticketFormId: isNZ ? FORM_ID_NZ : FORM_ID_AU,
  //   groupId: isProduction ? groupId : undefined,
  //   subject: "Hardship application",
  //   firstComment: getComment(param),
  //   customFields: getCustomFields(param),
  // });

  // return ticketResponse.data.ticket.id;
  return 0;
}
